import React, { Fragment } from "react";
import { fieldCategoryToFieldTypesMap } from "../../constants";
import {
  BuilderFieldButton,
  BuilderFieldCategoryName,
  BuilderFieldListItem,
  BuilderFieldsList,
} from "./__styles__/shared";

export function FieldsList() {
  return (
    <div>
      {Object.entries(fieldCategoryToFieldTypesMap).map(
        ([category, fieldTypes]) => (
          <Fragment key={category}>
            <BuilderFieldCategoryName>{category}</BuilderFieldCategoryName>
            <BuilderFieldsList>
              {fieldTypes.map(fieldType => (
                <BuilderFieldListItem key={fieldType.name}>
                  <BuilderFieldButton
                    styleVariant="ghost"
                    leftIconName={fieldType.icon}
                    aria-label={`Add ${fieldType.label} field`}
                  >
                    {fieldType.label}
                  </BuilderFieldButton>
                </BuilderFieldListItem>
              ))}
            </BuilderFieldsList>
          </Fragment>
        ),
      )}
    </div>
  );
}
